(function (global) {
  'use strict';

  if (global.__vlMobileVariantFeaturedMediaLoaded) return;
  global.__vlMobileVariantFeaturedMediaLoaded = true;

  var initialPreviewWidth = 160;
  var highResolutionWidth = 540;
  var requestSequence = 0;
  var earlyState = global.__mobileVariantFeaturedMediaEarlyState =
    global.__mobileVariantFeaturedMediaEarlyState || {
      ready: false,
      lastVariantInput: null,
      lastVariantId: null
    };

  function isEnabled(variantPicker) {
    return variantPicker && (
      variantPicker.classList.contains('ab-mobile-media--b') ||
      document.documentElement.dataset.mobileVariantMediaExperiment === 'b' ||
      document.documentElement.classList.contains('mobile-variant-media-preview')
    );
  }

  function getVariants(variantPicker) {
    var variantsData = variantPicker &&
      variantPicker.querySelector('[data-variant-picker-variants]');

    try {
      var variants = JSON.parse(variantsData ? variantsData.textContent : '[]');
      if (Array.isArray(variants) && variants.length) return variants;
    } catch (error) {
      // Fall back to the legacy product-level variant data below.
    }

    return Array.isArray(global.productVariants) ? global.productVariants : [];
  }

  function getImageUrl(source, width) {
    if (!source) return null;

    if (/[?&]width=\d+/.test(source)) {
      return source.replace(/([?&])width=\d+/, '$1width=' + width);
    }

    return source + (source.includes('?') ? '&' : '?') + 'width=' + width;
  }

  function loadInitial(root) {
    var variantPickers = root.matches && root.matches('variant-picker')
      ? [root]
      : root.querySelectorAll('variant-picker');

    variantPickers.forEach(function (variantPicker) {
      if (!isEnabled(variantPicker)) return;

      variantPicker.querySelectorAll('[data-mobile-variant-featured-media-image]')
        .forEach(function (image) {
          var initialSrc = image.dataset.mobileVariantFeaturedMediaInitialSrc;
          if (initialSrc && !image.getAttribute('src')) {
            image.dataset.mobileVariantPreviewRequestId = String(++requestSequence);
            image.src = initialSrc;
          }
        });
    });
  }

  function updatePreview(variantInput, capturedVariantId) {
    var productContent = variantInput.closest('product-content') ||
      variantInput.closest('.shopify-section') || document;
    var variantPicker = productContent.querySelector('variant-picker.product-variant-picker');
    if (!isEnabled(variantPicker)) return;

    var variantId = Number(
      capturedVariantId || variantInput.getAttribute('value') || variantInput.value
    );
    var variant = getVariants(variantPicker).find(function (item) {
      return Number(item.id) === variantId;
    });
    if (!variant) return;

    if (variant.featured_image && variant.featured_image.src) {
      var previewImageSrc = getImageUrl(
        variant.featured_image.src,
        initialPreviewWidth
      );
      var highResolutionPreviewImageSrc = getImageUrl(
        variant.featured_image.src,
        highResolutionWidth
      );
      var previewImages = productContent.querySelectorAll(
        '[data-mobile-variant-featured-media-image]'
      );
      var requestId = String(++requestSequence);

      previewImages.forEach(function (image) {
        image.dataset.mobileVariantPreviewId = String(variantId);
        image.dataset.mobileVariantPreviewRequestId = requestId;
        image.src = previewImageSrc;
        image.alt = variant.featured_image.alt || '';
      });

      if (highResolutionPreviewImageSrc &&
        highResolutionPreviewImageSrc !== previewImageSrc) {
        var highResolutionImage = new Image();
        highResolutionImage.onload = function () {
          previewImages.forEach(function (image) {
            if (image.dataset.mobileVariantPreviewId === String(variantId) &&
              image.dataset.mobileVariantPreviewRequestId === requestId) {
              image.src = highResolutionPreviewImageSrc;
            }
          });
        };
        highResolutionImage.src = highResolutionPreviewImageSrc;
      }
    }

    productContent.querySelectorAll('[data-mobile-variant-notice]')
      .forEach(function (notice) {
        notice.hidden = Number(notice.dataset.variantId) !== variantId;
      });
  }

  function syncCurrentVariant(variantPicker) {
    if (!isEnabled(variantPicker)) return;

    var productContent = variantPicker.closest('product-content') ||
      variantPicker.closest('.shopify-section') || document;
    var variantInput = productContent.querySelector(
      'input[data-product-form-variant][name="id"]'
    );

    if (!variantInput) return;

    var variantId = variantInput.getAttribute('value') || variantInput.value;
    var previewImage = productContent.querySelector(
      '[data-mobile-variant-featured-media-image]'
    );

    if (previewImage &&
      previewImage.dataset.mobileVariantPreviewId === String(variantId)) {
      return;
    }

    updatePreview(variantInput, variantId);
  }

  function handleVariantInputChange(event) {
    var variantInput = event.target.closest
      ? event.target.closest('.product input[data-product-form-variant]')
      : null;
    if (!variantInput) return;

    var variantId = variantInput.getAttribute('value') || variantInput.value;

    if (!earlyState.ready) {
      earlyState.lastVariantInput = variantInput;
      earlyState.lastVariantId = variantId;
    }

    updatePreview(variantInput, variantId);
  }

  global.setMobileVariantFeaturedMediaExperiment = function (group) {
    var experimentGroup = String(group).toLowerCase() === 'b' ? 'b' : 'a';
    document.documentElement.dataset.mobileVariantMediaExperiment = experimentGroup;

    document.querySelectorAll('variant-picker.product-variant-picker')
      .forEach(function (variantPicker) {
        variantPicker.classList.remove('ab-mobile-media--a', 'ab-mobile-media--b');
        variantPicker.classList.add('ab-mobile-media--' + experimentGroup);

        if (experimentGroup === 'b') {
          syncCurrentVariant(variantPicker);
        }
      });

    if (experimentGroup === 'a') {
      document.documentElement.classList.remove('mobile-variant-media-preview');
    } else {
      loadInitial(document);
    }

    return experimentGroup;
  };

  global.enableMobileVariantFeaturedMediaPreview = function () {
    document.documentElement.classList.add('mobile-variant-media-preview');
    global.setMobileVariantFeaturedMediaExperiment('b');
  };

  document.addEventListener('change', handleVariantInputChange, true);

  if (new URLSearchParams(global.location.search)
    .get('mobile_variant_media_preview') === '1') {
    global.enableMobileVariantFeaturedMediaPreview();
  }

  function initialize() {
    if (document.documentElement.dataset.mobileVariantMediaExperiment === 'b' ||
      document.documentElement.classList.contains('mobile-variant-media-preview')) {
      global.setMobileVariantFeaturedMediaExperiment('b');
    } else {
      loadInitial(document);
    }

    var previewGroupObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.target.matches('variant-picker')) {
          loadInitial(mutation.target);
          syncCurrentVariant(mutation.target);
        }
      });
    });

    previewGroupObserver.observe(document.body, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})(window);
